<template>
    <div style="width: 100%; height: 100%">
        <img :fit="option.attribute.fit" :src="option.attribute.url?image(option.attribute.url):require('@/assets/logo.jpg')" style="width: 100%; height: 100%"/>
    </div>
</template>

<script>

import {image} from "@/utils/Tool";

export default {
    name: "cpt-image",
    props: {option: Object},
    data() {
        return {}
    },
    methods: {
        image
    }
}
</script>

<style scoped>
</style>
